import { InnoTable, Popover } from "InnoUI/components";
import SC from "./style";
import { apiGet } from "api/callApi";
import { useEffect, useState } from "react";
import TimezoneConverter from "components/TimeZoneConvertor";
import TooltipText from "components/TooltipText";

const EmailSendHistory = (props) => {
  const { journalId } = props;
  const [data, setData] = useState([]);

  const getHistoryData = async () => {
    try {
      const response = await apiGet(
        `/v1/journal/getjournalhistory/${journalId}`
      );
      setData(response.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getHistoryData();
  }, [journalId]);

  const subColumnData = [
    {
      title: " Date & Time",
      dataIndex: "createdOn",
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        return (
          <span>
            <TimezoneConverter time={value} style={{ opacity: 0.7 }} />
          </span>
        );
      },
    },
    {
      title: "From",
      dataIndex: "createdByName",
      width: 250,
      sorter: (a, b) => a.createdByName.localeCompare(b.createdByName),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <span style={{ color: "black", opacity: "0.7" }}>
              <TooltipText title={value} maxLength={0} />
            </span>
          </>
        );
      },
    },
    {
      title: "TO",
      width: 200,
      dataIndex: "sendTo",
      render(value, record) {
        return (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: <SC.ParagaphStyle>{value}</SC.ParagaphStyle>,
            }}
            popoverContent={
              <SC.Table>
                <SC.Thead>
                  <SC.TR>
                    <SC.Th>TO</SC.Th>
                  </SC.TR>
                </SC.Thead>
                <SC.Tbody>
                  <SC.Tr>
                    <SC.Td>{value || "N/A"}</SC.Td>
                  </SC.Tr>
                </SC.Tbody>
              </SC.Table>
            }
          />
        );
      },
    },

    {
      title: "CC",
      dataIndex: "sendCc",
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        return (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: <SC.ParagaphStyle>{value}</SC.ParagaphStyle>,
            }}
            popoverContent={
              <SC.Table>
                <SC.Thead>
                  <SC.TR>
                    <SC.Th>CC</SC.Th>
                  </SC.TR>
                </SC.Thead>
                <SC.Tbody>
                  <SC.Tr>
                    <SC.Td>{value || "N/A"}</SC.Td>
                  </SC.Tr>
                </SC.Tbody>
              </SC.Table>
            }
          />
        );
      },
    },
    {
      title: "BCC",
      dataIndex: "sendBcc",
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        return (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: <SC.ParagaphStyle>{value}</SC.ParagaphStyle>,
            }}
            popoverContent={
              <SC.Table>
                <SC.Thead>
                  <SC.TR>
                    <SC.Th>BCC</SC.Th>
                  </SC.TR>
                </SC.Thead>
                <SC.Tbody>
                  <SC.Tr>
                    <SC.Td>{value || "N/A"}</SC.Td>
                  </SC.Tr>
                </SC.Tbody>
              </SC.Table>
            }
          />
        );
      },
    },
  ];
  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: false,
    pagination: {
      pageSize: 11,
    },
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
  };

  return (
    <div style={{ padding: "10px" }}>
      <SC.HeaderContainer>
        <SC.HeaderStyle>Sent Emails History</SC.HeaderStyle>
      </SC.HeaderContainer>
      <div style={{ paddingTop: "10px" }}>
        <InnoTable
          tableConfig={tableConfig}
          padding={"8px 8px 8px 8px"}
          column={subColumnData}
          data={data}
          tablepadding="0px"
        />
      </div>
    </div>
  );
};

export default EmailSendHistory;
